<template>
  <div>
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      v-cloak
      :header-text="$t('Team settings')"
      :is-open="modalOpen"
      :save-state="saveState"
      :remove-cancel-button="false"
      :cancel-button-text="$t('Cancel')"
      :confirm-button-text="$t('save')"
      modal-id="team-settings-modal"
      @opened="handleModalOpened"
      @negative-response="negativeResponse"
      @positive-response="positiveResponse"
      @cancel="modalOpen = false"
    >
      <div class="p-t-15 p-b-15">
        <slot />
        <EditSettingsOption
          v-model="user.enforceTwoFactorAuth"
          :label="$t('Require 2-factor authentication')"
          :help-info="$t('Require your team members to login using 2-factor authentication')"
        />
        <br />
      </div>
    </BaseModal>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import enums from '@/utils/enum'
import EditSettingsOption from '@/components/EditSettingsOption.vue'

export default {
  components: { EditSettingsOption },
  props: {
    openTrigger: { type: Boolean, default: false },
    enforceTwoFactorAuth: { type: Boolean, default: false },
  },
  data() {
    return {
      modalOpen: false,
      saveState: 'fresh',
      userHasInteractedWithContents: false,
      user: this.initialUserState(),
    }
  },
  watch: {
    modalOpen(newModalOpen) {
      if (!newModalOpen) {
        this.$emit('closed')
      }
    },
    openTrigger(newOpenProp) {
      if (newOpenProp) {
        this.triggerTheModal()
      }
    },
  },
  mounted() {
    if (this.openTrigger) {
      this.triggerTheModal()
    }
  },
  methods: {
    initialUserState() {
      return {
        enforceTwoFactorAuth: this.enforceTwoFactorAuth,
      }
    },
    handleModalOpened() {
      this.saveState = 'fresh'
    },
    positiveResponse() {
      this.saveAndDismiss(true)
    },
    negativeResponse() {
      this.modalOpen = false
    },
    async saveAndDismiss(shouldRefresh = false) {
      this.saveState = 'saving'
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation ($globalId: ID!, $enforceTwoFactorAuth: Boolean!) {
              updateCompany(
                input: {
                  globalId: $globalId
                  settings: { require_two_factor_auth: $enforceTwoFactorAuth }
                }
              ) {
                globalId
                settings {
                  require_two_factor_auth
                }
              }
            }
          `,
          // Parameters
          variables: {
            globalId: this.account.globalId,
            enforceTwoFactorAuth: this.user.enforceTwoFactorAuth,
          },
        })
        this.modalHasSavedActions()
        if (shouldRefresh) {
          window.location.reload()
        }
      } catch (e) {
        this.modalHasSaveFailedActions()
      }
    },
    modalHasSavedActions() {
      this.saveState = 'saved'
      setTimeout(() => {
        this.modalOpen = false
      }, 1000)
    },
    modalHasSaveFailedActions() {
      this.saveState = 'failed'
      this.$store.commit('sendNotification', {
        type: enums.notification.types.ERROR,
        sender: this,
        severity: enums.notification.severity.CRITICAL,
      })
      setTimeout(() => {
        this.saveState = 'fresh'
      }, 3000)
    },
    triggerTheModal() {
      this.modalOpen = true
    },
  },
}
</script>

<style scoped lang="scss"></style>
